import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { MainLayout } from '@/components/Layout';
import { About } from '@/features/about';
import { AuthRoutes } from '@/features/auth';
import { BuyCrypto } from '@/features/buycrypto';
import { Market } from '@/features/market';
import { Mentorship } from '@/features/mentorship';
import { PrivacyPolicy, TermsCondition } from '@/features/misc';
import { PublicProjectSlots } from '@/features/projectSlots';

const UnAuthenticatedRoutes = () => {
  return (
    <Routes>
      <Route path='about' element={<About />} />
      {/* <Route path='academy' element={<Academy />} /> */}
      <Route path='market' element={<Market />} />
      <Route path='buycrypto' element={<BuyCrypto />} />
      <Route
        path='project-slot'
        element={<Navigate to='/project-slots' replace />}
      />
      <Route path='project-slots' element={<PublicProjectSlots />} />
      <Route path='mentorship' element={<Mentorship />} />
      <Route path='privacy-policy' element={<PrivacyPolicy />} />
      <Route path='terms' element={<TermsCondition />} />
    </Routes>
  );
};

const DynamicMainLayout = () => {
  const location = useLocation();
  const page: string = location.pathname.split('/')[1];
  console.log('Public page:', page);

  return (
    <MainLayout page={page}>
      <UnAuthenticatedRoutes />
    </MainLayout>
  );
};

export const publicRoutes = [
  {
    path: '/auth/*',
    element: <AuthRoutes />,
  },
  {
    path: '/*',
    element: <DynamicMainLayout />,
  },
];
